<div class="cheat-day-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div class="cheat-day-scroll">
    <img class="cheat-day-top-image" src="assets/plan/cheatday.png" />
    <div class="cheat-day-close" (click)="closeCheatDay()">
      <img src="assets/general/down-white.svg" />
    </div>
    <div class="cheat-day-title">روز آزاد</div>
    <div *ngIf="!isPredefined" class="cheat-day-description">
      روز آزاد روزی است که می‌توانید به برنامه غذایی عمل نکنید. در هر برنامه
      غذایی ۲ روز آزاد دارید.
    </div>
    <div *ngIf="!planLock && isPredefined" class="cheat-day-description">
      برنامه غذایی {{ dietType }} روز آزاد ندارد. برای داشتن روز آزاد باید
      برنامه غذایی شخصی سازی شده بگیرید.
    </div>
    <div
      *ngIf="!planLock && !isPredefined && isCheatDayAcitve"
      class="cheat-day-remaining"
    >
      وضعیت
    </div>
    <div
      *ngIf="
        !planLock && !isPredefined && isCheatDayAcitve && cheatDayCount === '0'
      "
      class="cheat-day-first"
    >
      روز آزاد اول
    </div>
    <div
      *ngIf="
        !planLock && !isPredefined && isCheatDayAcitve && cheatDayCount !== '0'
      "
      class="cheat-day-first"
      style="text-decoration: line-through"
    >
      روز آزاد اول
    </div>
    <div
      *ngIf="
        !planLock && !isPredefined && isCheatDayAcitve && cheatDayCount !== '2'
      "
      class="cheat-day-second"
    >
      روز آزاد دوم
    </div>
    <div
      *ngIf="
        !planLock && !isPredefined && isCheatDayAcitve && cheatDayCount === '2'
      "
      class="cheat-day-second"
      style="text-decoration: line-through"
    >
      روز آزاد دوم
    </div>
    <div
      *ngIf="!planLock && !isPredefined && dietId === '1'"
      class="cheat-day-get-diet-title"
    >
      برای استفاده از این قابلیت، برنامه غذایی دریافت کنید.
    </div>
    <div
      *ngIf="!planLock && !isPredefined && dietId === '0'"
      class="cheat-day-get-diet-title"
    >
      برای این روز برنامه غذایی ندارید
    </div>
    <div *ngIf="planLock" class="cheat-day-get-diet-title">
      اشتراک شما به پایان رسیده است برای استفاده از این قابلیت اشتراک تهیه کنید
    </div>
  </div>
  <div
    *ngIf="
      !planLock &&
      !isPredefined &&
      isCheatDayAcitve &&
      (isCheatDay || cheatDayCount === '2')
    "
    class="cheat-day-submit"
    (click)="swipe(SWIPE_ACTION.LEFT)"
    (swiperight)="swipe($event.type)"
    (swipeleft)="swipe($event.type)"
  >
    <div class="cheat-day-submit-title" id="cheat-day-submit-title"></div>
    <div class="cheat-day-submit-icon-active" id="cheat-day-submit-icon">
      <img src="assets/plan/cheatdayEmoji.svg" />
    </div>
  </div>
  <div
    *ngIf="
      !planLock &&
      !isPredefined &&
      isCheatDayAcitve &&
      !isCheatDay &&
      cheatDayCount !== '2'
    "
    class="cheat-day-submit"
    (click)="swipe(SWIPE_ACTION.LEFT)"
    (swiperight)="swipe($event.type)"
    (swipeleft)="swipe($event.type)"
  >
    <div class="cheat-day-submit-title" id="cheat-day-submit-title">
      برای انتخاب روز آزاد به راست بکشید
    </div>
    <div class="cheat-day-submit-icon" id="cheat-day-submit-icon">
      <img src="assets/plan/cheatdayEmoji.svg" />
    </div>
  </div>
  <app-submit-button
    *ngIf="!planLock && !isPredefined && dietId === '1'"
    [title]="'برنامه غذایی دریافت کنید'"
  ></app-submit-button>
  <app-submit-button
    *ngIf="planLock"
    [title]="'اشتراک تهیه کنید'"
  ></app-submit-button>
  <div
    *ngIf="!planLock && isPredefined"
    class="cheat-day-return-button"
    (click)="closeCheatDay()"
  >
    بازگشت
  </div>
  <app-ios-bottomsheet
    *ngIf="showIosBottomsheet"
    [input]="iosBottomsheetInput"
  ></app-ios-bottomsheet>
</div>
